export const FOCUSABLE_ELEMENTS_QUERY = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'details',
    '[tabindex]:not([tabindex="-1"])',
].map((el) => `:not(ap-shell):not(ap-app-bar):not(ap-nav) ${el}:not([disabled])`).join(', ');
